__webpack_require__.p = "/Speed-Typing-Game/";